import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../components/Buttons';
import { Loader } from '../../../../components/Loader';
import { Modal, ModalControls } from '../../../../components/Modal';
import { selectWorks } from '../../../Api/selectors';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { Cell } from '../Cell';
import { BaseCellComp } from '../BaseCellComp';
import {
  addVehicleToBulkActionsList,
  assignVehicleTransport,
  removeVehicleFromBulkActionsList,
} from '../../../Vehicles/actions';
import { refreshBoards } from '../../actions';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../../../Vehicles/constants';
import { HBox, VBox } from '../../../../components/Box';
import { formatLicensePlate } from '../../../../utils/string';
import { AddressFields } from '../../../Address/components/AddressFields';
import { CompanyLabelById } from '../../../Companies/components/CompanyLabelById';
import { VehicleStatusLabel } from '../../../Vehicles/components/VehicleStatusLabel';
import { Label, getLabelColor } from '../../../Vehicles/components/VehicleCounterLabel';
import { VehiclePropertyEditableInput } from '../../../Vehicles/components/VehiclePropertyEditableInput';
import { Checkbox } from '../../../../components/Checkbox';
import { selectVehicleBulkActionsKanbanTaskName, selectVehicleBulkActionsList } from '../../../Vehicles/selectors';
import { swapKeyValues } from '../../../../utils/object';
import { selectCompanyProperty } from '../../../Companies/selectors';
import { REQUEST_COMPANIES_PROPERTY } from '../../../Companies/constants';
import { REQUEST_ADDRESSES_BY_IDS } from '../../../Address/constants';
import { selectAddress } from '../../../Address/selectors';

import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import styles from './Transport.module.css';
import cn from 'classnames';
//change this for values of counters
const ranges = {
  MediumSeaGreen: [1, 3],
  DarkOrange: [4, 6],
  Crimson: [7, Infinity],
};
const Container = styled.div`
  .modal-inner {
    margin-bottom: 120px;
  }
  p {
    margin: 0;
  }

  .col-regplate-vin {
    max-width: 200px;
  }

  .col-model-info {
    min-width: 150px;
    max-width: 150px;
  }

  .col-address-from {
    min-width: 250px;
    max-width: 250px;
  }

  .col-address-to {
    min-width: 200px;
    max-width: 200px;
  }
  .regplate {
    font-size: 14px;
  }
  font-size: 12px;
`;

const STATE = {
  approve: false,
  selected: null,
  loading: false,
};

export const TransportAssignable = {
  trailer_1: '9',
  trailer_2: '10',
  trailer_3: '11',
  trailer_4: '12',
  trailer_5: '13',
  trailer_6: '14',
  trailer_7: '15',
  trailer_8: '16',
  trailer_9: '17',
  trailer_10: '18',
  Intern: '19',
};

export const TransportAssignableSortMap = swapKeyValues(TransportAssignable);
export const TransportAssignableOptions = _.map(TransportAssignable, (value, name) => ({ label: name, value: value }));

/* eslint-disable react/prefer-stateless-function */
class Transport_in_euComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  confirm() {
    //apprive BVI ...
    this.props.confirm(this.vehicle.id);
  }

  get vehicle() {
    return this.props.cell.vehicle;
  }

  get action() {
    return this.props.action;
  }

  get bulkActionsList() {
    let list = [];
    if (this.props.bulkActionsList?.length) {
      list = this.props.bulkActionsList;
    }
    return list;
  }

  isSelectedVehicle() {
    return this.bulkActionsList?.filter(item => item?.id == this.vehicle?.id)?.length == 1;
  }

  onSelectVehicle(e, vehicle) {
    e.stopPropagation();
    if (this.isSelectedVehicle(vehicle?.id)) {
      return this.props.removeVehicleFromBulkActionsList(vehicle?.id);
    }

    return this.props.addVehicleToBulkActionsList(vehicle, this.action.functionName);
  }

  renderApprove() {
    console.log('this.props.work', this.props.work);
    if (this.props.work) return null;
    if (!this.state.approve) return null;
    if (!this.vehicle) return '...';
    return (
      <ModalComponent onClose={this.reset.bind(this)} title={this.lbl('kanbanboards.cell.Transport_in_eu.modal.title')}>
        <div className={styles.buttonGrid}>
          {TransportAssignableOptions.map(a => (
            <Button
              className={styles.buttonItem}
              primary={a.value == this.state.selected}
              key={a.label}
              onClick={this.setStateFn({ selected: a.value })}
            >
              {a.label.replace(/\_/g, ' ')}
            </Button>
          ))}
        </div>
        <VehiclePropertyEditableInput propertyName="amount_transport_eu_in" vehicle_id={this.vehicle.id} />
        <VehiclePropertyEditableInput propertyName="transporter_eu_in" vehicle_id={this.vehicle.id} />
        <VehiclePropertyEditableInput propertyName="date_expected_start_eu_in" vehicle_id={this.vehicle.id} />
        <VehiclePropertyEditableInput propertyName="amount_of_vehicles_in" vehicle_id={this.vehicle.id} />

        <div className="d-flex gap-2 mt-2">
          {this.props.work || this.state.loading ? (
            <Loader small />
          ) : (
            <>
              <ButtonComponent
                style={'ButtonSoftEdit'}
                onClick={() => {
                  this.setState({ loading: true });
                  this.props.assign(this.state.selected, this.reset.bind(this));
                }}
              >
                {this.lbl('save')}
              </ButtonComponent>
              <ButtonComponent style={'ButtonSoftDelete'} onClick={this.reset.bind(this)}>
                {this.lbl('cancel')}
              </ButtonComponent>
            </>
          )}
        </div>
      </ModalComponent>
    );
  }

  render() {
    const vehicle = this.vehicle;
    return (
      <Cell className={styles.cell}>
        <Container onClick={this.setStateFn({ approve: !this.state.approve })}>
          {this.props.cell.busy ? <Loader small /> : null}
          <HBox className={styles.containerTransport} vCenter>
            <Checkbox checked={this.isSelectedVehicle()} onChange={e => this.onSelectVehicle(e, vehicle)} />
            <VBox left className="regplate col-regplate-vin">
              <span style={{ fontWeight: 600 }}> {formatLicensePlate(vehicle.regplate)}</span>
              <span style={{ opacity: 0.4 }}>{vehicle.vin || ''}</span>
            </VBox>
            <VBox left className="col-model-info">
              <p style={{ fontWeight: 600 }}>{vehicle.brand_name}</p>
              <p>{vehicle.model_name}</p>
            </VBox>
            <VBox left className={cn('address col-address-from', styles.address)}>
              {(this.props.companyName || this.props.loadSingleRes) && (
                <CompanyLabelById
                  fetchName
                  transportCard
                  transport_to={vehicle?.transport_incoming_from_company_name}
                  company_id={vehicle?.transport_incoming_from_company_id}
                />
              )}
              {this.props.address && (
                <AddressFields inlineshort addressId={vehicle.transport_from_address_id} />
              )}
            </VBox>
            {/* <VBox left className="address col-address-to">
              <CompanyLabelById
                fetchName
                transportCard
                transport_to={vehicle?.transport_incoming_to_company_name}
                company_id={vehicle.buying_company}
              />
              <AddressFields inlineshort addressId={vehicle.transport_to_address_id} />
            </VBox> */}{' '}
            <VehicleStatusLabel color={vehicle?.incoming_invoice_payment_status ? '#15AC79' : 'red'}>
              {vehicle?.incoming_invoice_payment_status ? 'betaald' : 'niet betaald'}
            </VehicleStatusLabel>
            <VehicleStatusLabel>in</VehicleStatusLabel>
            <Label count={vehicle?.transportinkomend} ranges={ranges}>
              {vehicle?.transportinkomend || '0'}
            </Label>
          </HBox>
        </Container>
        {this.renderApprove()}
        <HBox style={{ fontSize: '12px' }} onClick={this.tofn(`/vehicles/${vehicle.id}`)}>
          {vehicle.id}{' '}
        </HBox>
      </Cell>
    );
  }
}

Transport_in_euComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([
      `${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle.id}`,
      REQUEST_VEHICLE_PROPERTY_UPDATE,
      REQUEST_COMPANIES_PROPERTY,
      REQUEST_ADDRESSES_BY_IDS,
    ]),
    bulkActionsList: selectVehicleBulkActionsList(),
    bulkActionTask: selectVehicleBulkActionsKanbanTaskName(),
    companyName: selectCompanyProperty(ownProps.cell.vehicle.transport_incoming_from_company_id, 'name'),
    address: selectAddress(ownProps.cell.vehicle.transport_from_address_id),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    addVehicleToBulkActionsList(vehicle, kanbanTaskName) {
      dispatch(addVehicleToBulkActionsList(vehicle, [], kanbanTaskName));
    },
    removeVehicleFromBulkActionsList(vehicleId) {
      dispatch(removeVehicleFromBulkActionsList(vehicleId));
    },
    //
    assign(id, callback) {
      dispatch(
        assignVehicleTransport(ownProps.cell.vehicle.id, `${id}`, false, false, () => {
          dispatch(refreshBoards());
          callback();
        }),
      );
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const Transport_in_eu = compose(withConnect, withRouter)(Transport_in_euComp);
